import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FlagBackdrop } from "@/components/midterms/FlagBackdrop";
import { PartyLogo } from "@/components/midterms/PartyLogo";
import { MapExplorer } from "@/components/midterms/MapExplorer";
import { Chambers, FeedStatus, useMidtermsHub } from "@/components/midterms/Chambers";

export default function MidtermsHub() {
  const hub = useMidtermsHub();
  if (!hub || !hub.senate?.total_up) return null;

  return (
    <section className="relative isolate overflow-hidden bg-[#07112e] text-white px-4 sm:px-6 lg:px-10 py-14 md:py-20" data-testid="midterms-hub">
      <FlagBackdrop />
      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 border-b border-white/20 pb-6 mb-10">
          <div>
            <FeedStatus feed={hub.feed} />
            <h2 className="mt-3 font-display text-5xl sm:text-6xl md:text-7xl font-black tracking-[-0.04em] leading-[0.9]">
              Midterms <span className="text-[#E81B23]">&rsquo;26</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-white/70 max-w-2xl">
              The battle for Congress and the statehouses, state by state. Live counts for the Senate, House and
              36 governor races, straight from state election offices.
            </p>
          </div>
          <div className="flex items-center gap-4 md:gap-6">
            <PartyLogo party="D" size={64} className="midterms-float ring-4 ring-white/10" />
            <span className="font-display text-xl font-black text-white/40">vs</span>
            <PartyLogo party="R" size={64} className="midterms-float-alt ring-4 ring-white/10" />
            <Link
              to="/midterms"
              className="hidden sm:inline-flex ml-2 items-center gap-2 border border-white/30 px-4 py-2.5 text-[11px] uppercase tracking-[0.22em] font-bold hover:bg-white hover:text-[#07112e] transition-colors"
              data-testid="midterms-hub-cta"
            >
              Full results <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <Chambers hub={hub} />

        <div className="mt-12">
          <MapExplorer hub={hub} />
        </div>

        <div className="mt-10 sm:hidden text-[10px] uppercase tracking-[0.18em]">
          <Link to="/midterms" className="inline-flex items-center gap-1 font-bold text-white" data-testid="midterms-hub-cta-mobile">
            Full results <ArrowUpRight size={12} />
          </Link>
        </div>
      </div>
    </section>
  );
}
